<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <v-row>
        <v-col cols="12" sm="6" md="7" class="py-2 py-sm-0">
          <v-form @submit="search">
            <div class="position-relative search-text">
              <v-text-field
                class="font--secondary"
                dense
                outlined
                v-bind="fieldProps"
                hide-details
                name="q"
                v-model="q"
                label="Faça sua busca"
                required
              ></v-text-field>

              <v-btn
                class="primary--text search-text-submit"
                min-width="36px"
                color="white"
                height="36px"
                type="submit"
                width="36px"
                depressed
              >
                <v-icon size="18"> fa fa-search </v-icon>
              </v-btn>
            </div>
          </v-form>
        </v-col>

        <v-col cols="12" sm="6" md="5" class="py-2 py-sm-0">
          <v-select
            class="font--secondary"
            dense
            v-bind="fieldProps"
            @change="changeCategory"
            outlined
            hide-details
            v-model="category"
            :items="[
              ...[
                {
                  text: 'Todas',
                  value: path,
                },
              ],
              ...filterCategories,
            ]"
            label="Selecionar Categoria"
          ></v-select>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import { mixin } from "../forms/fields/mixin";

export default {
  mixins: [mixin],
  data: () => ({
    q: "",
    category: "",
  }),
  props: {
    path: {
      type: String,
      default: "/produtos",
    },
  },
  computed: {
    filterCategories() {
      return this.$rest("products-categories").list.map(({ title }) => ({
        text: title,
        value: `${this.path}/${formatToURL(title)}`,
      }));
    },
  },
  mounted() {
    this.$rest("products-categories").get();
  },
  methods: {
    changeCategory() {
      if (this.$route.path != this.category) this.$router.push(this.category);
    },
    search(event) {
      event.preventDefault();

      if (this.q === "") return false;

      const query = {};
      query.q = this.q;

      this.$router.push({ query });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-text {
  &-submit {
    position: absolute;
    right: 2px;
    top: 2px;
  }
}
</style>
